export default __webpack_public_path__ + "static/media/search.ee9b9b32.png";